import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Tabs,
  Tab,
} from "@mui/material";

import { useApi } from "../utils/api";
import DosyaTurleriYonetim from "../components/DosyaTurleriYonetim";

const UcretAyarlariTab = () => {
  const http = useApi();

  const [form, setForm] = useState({
    net_saatlik_asgari: "",
    net_aylik_asgari: "",
    brut_saatlik_asgari: "",
    brut_aylik_asgari: "",
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await http.get("/ucret-ayarlari");
        setForm({
          net_saatlik_asgari: data.net_saatlik_asgari,
          net_aylik_asgari: data.net_aylik_asgari,
          brut_saatlik_asgari: data.brut_saatlik_asgari,
          brut_aylik_asgari: data.brut_aylik_asgari,
        });
      } catch (err) {
        setError("Ücret ayarları yüklenemedi.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [http]);

  const handleChange = (key, value) => {
    setForm((s) => ({ ...s, [key]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError("");
    setSuccess("");

    try {
      await http.put("/ucret-ayarlari", {
        net_saatlik_asgari: Number(form.net_saatlik_asgari),
        net_aylik_asgari: Number(form.net_aylik_asgari),
        brut_saatlik_asgari: Number(form.brut_saatlik_asgari),
        brut_aylik_asgari: Number(form.brut_aylik_asgari),
      });

      setSuccess("Ücret ayarları başarıyla güncellendi.");
    } catch (err) {
      setError("Kayıt sırasında hata oluştu.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ py: 4, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 700 }}>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
        Ücret Ayarları
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Personel eklerken otomatik gelecek asgari ücret değerlerini buradan
        belirleyebilirsiniz.
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" fontWeight={600}>Net Ücret</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Net Saatlik Asgari"
            type="number"
            fullWidth
            value={form.net_saatlik_asgari}
            onChange={(e) => handleChange("net_saatlik_asgari", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Net Aylık Asgari"
            type="number"
            fullWidth
            value={form.net_aylik_asgari}
            onChange={(e) => handleChange("net_aylik_asgari", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="subtitle1" fontWeight={600}>Brüt Ücret</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Brüt Saatlik Asgari"
            type="number"
            fullWidth
            value={form.brut_saatlik_asgari}
            onChange={(e) => handleChange("brut_saatlik_asgari", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Brüt Aylık Asgari"
            type="number"
            fullWidth
            value={form.brut_aylik_asgari}
            onChange={(e) => handleChange("brut_aylik_asgari", e.target.value)}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? <CircularProgress size={20} /> : "Kaydet"}
        </Button>
      </Box>
    </Box>
  );
};

const Settings = () => {
  const [tab, setTab] = useState(0);

  return (
    <Paper sx={{ p: 0 }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}
      >
        <Tab label="Ücret Ayarları" />
        <Tab label="Dosya Türleri" />
      </Tabs>

      <Box sx={{ p: 3 }}>
        {tab === 0 && <UcretAyarlariTab />}
        {tab === 1 && <DosyaTurleriYonetim />}
      </Box>
    </Paper>
  );
};

export default Settings;
